export default __webpack_public_path__ + "static/media/Neo.62460c50.png";